/**
 * Single source of truth for runtime API config. All values are inlined at
 * build time via Vite — never put secrets here. The backend handles auth.
 *
 * In dev, leave VITE_API_BASE_URL blank: vite.config.ts proxies /api/** to
 * http://localhost:8080 so the browser doesn't deal with CORS.
 */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  oauthIssuerUrl: import.meta.env.VITE_OAUTH_ISSUER_URL ?? '',
  oauthClientId: import.meta.env.VITE_OAUTH_CLIENT_ID ?? 'voltpassport-web',
  passportBaseUrl: import.meta.env.VITE_PASSPORT_BASE_URL ?? ''
} as const;
